import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { companyInfo } from '../mock';
import { toast } from '../hooks/use-toast';

const Newsletter = () => {
  const { language } = useLanguage();
  const [email, setEmail] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email) {
      toast({
        title: language === 'en' ? "Success!" : "¡Éxito!",
        description: language === 'en' 
          ? "You're on the list! Check your inbox to confirm your subscription."
          : "¡Estás en la lista! Revisa tu bandeja de entrada para confirmar tu suscripción."
      });
      setEmail('');
    }
  };

  return (
    <section className="py-20 bg-gradient-to-r from-blue-900 to-blue-800 text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10" style={{
        backgroundImage: 'url("data:image/svg+xml,%3Csvg width="40" height="40" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="%23ffffff" fill-opacity="1" fill-rule="evenodd"%3E%3Cpath d="M0 40L40 0H20L0 20M40 40V20L20 40"/%3E%3C/g%3E%3C/svg%3E")'
      }}></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="mb-8">
            <img
              src="https://images.pexels.com/photos/8439664/pexels-photo-8439664.jpeg"
              alt="Insurance Advisor"
              className="w-32 h-32 rounded-full mx-auto object-cover border-4 border-white/30 shadow-xl"
            />
          </div>
          
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            {language === 'en' 
              ? 'Your Insurance Agent With a Personal Touch'
              : 'Su Agente de Seguros con un Toque Personal'}
          </h2>
          
          <p className="text-xl text-blue-100 mb-8">
            {language === 'en'
              ? 'Sign up to receive awesome content in your inbox, every month.'
              : 'Regístrese para recibir contenido increíble en su bandeja de entrada, cada mes.'}
          </p>

          <form onSubmit={handleSubmit} className="max-w-md mx-auto flex gap-3">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={language === 'en' ? 'Enter your email' : 'Ingrese su correo electrónico'}
              className="flex-1 px-6 py-4 rounded-full text-gray-900 focus:outline-none focus:ring-2 focus:ring-white/50"
              required
            />
            <button
              type="submit"
              className="bg-white text-blue-900 px-8 py-4 rounded-full font-semibold hover:bg-blue-50 transition-all duration-300 shadow-lg hover:shadow-xl"
            >
              {language === 'en' ? 'Subscribe' : 'Suscribirse'}
            </button>
          </form>

          <p className="text-sm text-blue-200 mt-4">
            {language === 'en'
              ? "We don't spam! Read our privacy policy for more info."
              : "¡No enviamos spam! Lea nuestra política de privacidad para más información."}
          </p>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-10 right-10 w-32 h-32 bg-blue-400/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-10 left-10 w-40 h-40 bg-blue-600/10 rounded-full blur-3xl"></div>
    </section>
  );
};

export default Newsletter;